import { SubscriptionExpiry } from './SubscriptionExpiry'

export const SubscriptionExpiryContainer = SubscriptionExpiry
